import React, {useEffect, useState} from 'react';
import {Grid, Layout} from 'antd';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import CookieConsent from '../CookieConsent';
import {useTheme} from '../ThemeProvider';
import './AppLayout.css';

const { Content } = Layout;
const { useBreakpoint } = Grid;

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const screens = useBreakpoint();
  const { isDark } = useTheme();

  // Initialize collapsed state - always start collapsed (hidden) on mobile, respect localStorage on desktop
  const [collapsed, setCollapsed] = useState(true);

  // Initialize collapsed state based on screen size
  useEffect(() => {
    if (screens.md !== undefined) {
      if (screens.md) {
        // Desktop: check localStorage
        const saved = localStorage.getItem('sidebarCollapsed');
        if (saved !== null) {
          setCollapsed(JSON.parse(saved));
        } else {
          setCollapsed(false);
        }
      } else {
        // Mobile: always start collapsed
        setCollapsed(true);
      }
    }
  }, [screens.md]);

  // Save collapsed state to localStorage (only for desktop)
  useEffect(() => {
    if (screens.md) {
      localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed));
    }
  }, [collapsed, screens.md]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar
        collapsed={collapsed}
        screens={screens}
        onMenuClick={() => {
          // Close sidebar on mobile when menu item is clicked
          if (!screens.md) {
            setCollapsed(true);
          }
        }}
      />

      {/* Mobile backdrop overlay */}
      {!screens.md && !collapsed && (
        <div
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            zIndex: 999,
            transition: 'opacity 0.3s ease',
          }}
        />
      )}

      <Layout
        style={{
          marginLeft: screens.md ? (collapsed ? 80 : 240) : 0,
          transition: 'margin-left 0.2s ease',
        }}
      >
        <TopBar
          collapsed={collapsed}
          onToggleSidebar={toggleSidebar}
        />

        <Content
          className={isDark ? 'app-content dark' : 'app-content'}
          style={{
            overflow: 'initial',
            padding: screens.md ? '16px' : '1px',
          }}
        >
          {children}
        </Content>

        <Layout.Footer
          style={{
            textAlign: 'center',
            background: isDark ? '#141414' : '#f0f2f5',
            color: isDark ? '#fff' : '#000',
            padding: screens.md ? '24px 50px' : '16px',
          }}
        >
          <div style={{ fontSize: '12px', color: isDark ? '#595959' : '#8c8c8c' }}>
            metagame.news ©{new Date().getFullYear()}
          </div>
        </Layout.Footer>

        <CookieConsent />
      </Layout>
    </Layout>
  );
};

export default AppLayout;
